module.exports = __webpack_public_path__ + "img/jomalone.db1f328f.png";